import React from 'react';

import { Heading, Slide, Section, preloader } from 'spectacle-ppa';
import TeamNames from 'components/teamNames';

import videoSlide from '../../baseSlides/videoSlide';
import balloonSlide from '../../baseSlides/balloonSlide';

import MarkdownScript from 'helpers/markdownScript';
import markdownFile from './teamCreation.md';

import apprenticesRowArmsFolded from '../../images/characters/apprenticesRowArmsFolded.png';
import apprenticeHandsHips from '../../images/characters/apprenticeHandsHips.png';
import apprenticeArmsFolded from '../../images/characters/apprenticeArmsFolded.png';
import apprenticePointingDiagonal from '../../images/characters/apprenticePointingDiagonal.png';

const md = new MarkdownScript(markdownFile);

export function preloadGameShow () {
  preloader([
    apprenticesRowArmsFolded,
    apprenticeHandsHips,
    apprenticeArmsFolded,
    apprenticePointingUp
  ]);
}

function teamCreationSection ({ regionData }) {
  return (
    <Section id="team-creation">

      {/* Sara and Ian talk about teams and team names */}
      {videoSlide({
        id: 'intro',
        notes: md.getSubSectionAsHtml('Intro Video', 'Notes', false, regionData),
        youTubeId: md.getSectionMetadata('Intro Video', 'YouTube', regionData)
      })}

      {/* Get into teams and come up with a cool name */}
      {balloonSlide({
        id: 'get-into-teams',
        characterSide: 'right',
        characterImage: apprenticeArmsFolded,
        notes: md.getSubSectionAsHtml('Get Into Teams', 'Notes', false, regionData),
        html: md.getSubSectionAsHtml('Get Into Teams', 'Content', false, regionData)
      })}

      {/* Enter team names */}
      <Slide
          id="assign"
          bgColor="black"
          notes="<h2>Assign Team Names</h2>"
          teamNames>
        <div className="ui-slide">
          <Heading size={1}>
            Name your teams!
          </Heading>
          <TeamNames />
        </div>
      </Slide>

      {/* Scoring intro */}
      {balloonSlide({
        id: 'scoring-intro',
        characterSide: 'right',
        characterImage: apprenticeHandsHips,
        notes: md.getSubSectionAsHtml('Scoring Intro', 'Notes', false, regionData),
        html: md.getSubSectionAsHtml('Scoring Intro', 'Content', false, regionData)
      })}

      {/* Introduce scoreboard */}
      {balloonSlide({
        id: 'scoreboard-intro',
        characterSide: 'right',
        characterImage: apprenticePointingDiagonal,
        notes: md.getSubSectionAsHtml('Scoreboard Intro', 'Notes', false, regionData),
        html: md.getSubSectionAsHtml('Scoreboard Intro', 'Content', false, regionData)
      })}

      {/* ID cards draw your avatar */}
      {balloonSlide({
        id: 'id-cards',
        characterSide: 'left',
        characterImage: apprenticesRowArmsFolded,
        notes: md.getSubSectionAsHtml('ID Cards', 'Notes', false, regionData),
        html: md.getSubSectionAsHtml('ID Cards', 'Content', false, regionData)
      })}

    </Section>

  );
}

export default teamCreationSection;



// WEBPACK FOOTER //
// ./programs/zeroHeroes/sections/10_teamCreation/teamCreationSection.jsx